import { Component,ElementRef,inject, ViewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatBadge } from '@angular/material/badge';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AesEncDecService } from '../../../core/services/aes/aes-enc-dec.service';
import { MatButton } from '@angular/material/button';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [MatIcon,MatBadge,CommonModule,MatButton],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss'
})
export class NotificationComponent {
  localStorage = inject(AesEncDecService);

  private router = inject(Router);
  daysRemaining: number =0;
  PwdChangeDate:Date;
  userId:string;
  notifyNumber:number=0;
  showDialog: boolean = false;
  message:string;
  @ViewChild('dropdownToggle', { static: false }) dropdownToggle!: ElementRef;
  @ViewChild('dropdownMenu', { static: false }) dropdownMenu!: ElementRef;
  ngOnInit(): void {
    debugger;
    const jsonData = this.localStorage?.getData("loginDetails")?.toString() || '{}';
    const dataArray = JSON.parse(jsonData);
    const firstObject = dataArray[0];
    // Extract the data
    this.PwdChangeDate = new Date(firstObject.pwdChangeDate);
    this.userId = firstObject.userId;
    // Calculate the number of days remaining until the password expires
    const currentDate = new Date();
    const expiryDate = new Date(this.PwdChangeDate);
    expiryDate.setDate(expiryDate.getDate() + 90); // Assuming password expires in 90 days

    const timeDiff = expiryDate.getTime() - currentDate.getTime();
    this.daysRemaining = Math.ceil(timeDiff / (1000 * 3600 * 24)); 
    if (this.daysRemaining === 0 || this.daysRemaining <= 20) {
      this.showDialog = true;
      this.notifyNumber++;
      this.message = this.daysRemaining === 0
        ? "Your password will expire today. Please change the password before it gets expired."
        : `Your password will expire in ${this.daysRemaining} days. Please change the password before it expires.`;
    }
   
  }
  ngAfterViewInit() {
    if (this.showDialog && this.dropdownToggle) {
      setTimeout(() => {
this.dropdownToggle.nativeElement.click();
      }, 500); // Delayed to ensure the view is fully loaded
    }
  } 

      reset(): void {
   this.localStorage.saveData("loginUserId", JSON.stringify(this.userId));
  this.router.navigateByUrl('reset-password');
}


  }

  


